const BUSINESS_CONTEXTS = Object.freeze({
  FOR_RENT: 'RENT',
  FOR_SALE: 'SALE',
});

export default BUSINESS_CONTEXTS;
